<script>
import { Line } from "vue-chartjs";
export default {
	extends: Line,
	props: ["graphs", "timespan", "productId"],
   methods: {
      compileGraphs() {


      }

   },

   		// graphObject.datasets = [
         // 	{
         // 		label: "Data One",
         // 		backgroundColor: "rgb(123,54,48)",
         // 		data: [40, 39, 10, 40, 39, 800, 500],
         // 	},
         // 	{
         // 		label: "Data Two",
         // 		backgroundColor: "#rgb(248,83,54)",
         // 		data: [39, 434, 498, 234, 548, 459],
         // 	},
		// ];

	mounted() {
		let graphObject = {};
      let deltaT = -1;
		if ((this.timespan = "month")) {
			graphObject.labels = ["Woche 1", "Woche 2", "Woche 3", "Woche 4"];
         deltaT = 30;
		}
      axios.get(`mds/sales/by_product_id/${this.productId}`)
      .then( response => {
         console.log(response);
         dataByMarket = {};
         for(let data of response.data) {
            if(!(data.marketId in dataByMarket)) {
               dataByMarket[data.marketId] = {};
            }
           
            /*
               dateCreated: "2021-11-10T17:00:00.000Z"
               id: 2
               marketId: 2
               productId: 2
               quantity: 1
               retailPrice: 1.911
               retailPriceInEuro: 2.34
               vendorId: 123
            */           


         }

         this.renderChart(
            datasets, 
            {
               responsive: true,
               maintainAspectRatio: false,
            }
         );
      });

	},
};
</script>
